
import { Component, Prop, Vue } from 'vue-property-decorator';
import { VNode } from 'vue';

interface CachedCmsLayer {
    routeKey: string;
    vnode: VNode;
}

@Component({
    name: 'CmsLayerKeepAlive',
    abstract: true,
} as any)
export default class CmsLayerKeepAlive extends Vue {
    @Prop({ required: true }) private layer!: string;

    private cache: Record<string, CachedCmsLayer> = Object.create(null);
    private vnodeToCache: VNode | null = null;
    private replacedVnodes: VNode[] = [];

    private mounted() {
        this.cacheVNode();
    }

    private updated() {
        this.cacheVNode();
        this.destroyReplacedVnodes();
    }

    private destroyed() {
        Object.values(this.cache).forEach(({ vnode }) => vnode.componentInstance?.$destroy());
    }

    private cacheVNode() {
        if (this.vnodeToCache == null) {
            return;
        }

        const routeKey = String(this.vnodeToCache.key);
        const cachedLayer = this.cache[this.layer];

        if (cachedLayer != null && cachedLayer.routeKey !== routeKey) {
            this.replacedVnodes.push(cachedLayer.vnode);
        }

        this.cache[this.layer] = {
            routeKey,
            vnode: this.vnodeToCache,
        };
        this.vnodeToCache = null;
    }

    private destroyReplacedVnodes() {
        this.replacedVnodes.forEach((vnode) => vnode.componentInstance?.$destroy());
        this.replacedVnodes = [];
    }

    private render(): VNode | undefined {
        const vnode = this.$slots.default?.find((node) => node.componentOptions != null);

        if (vnode == null) {
            return undefined;
        }

        const routeKey = String(vnode.key);
        const cachedLayer = this.cache[this.layer];

        if (cachedLayer != null && cachedLayer.routeKey === routeKey) {
            vnode.componentInstance = cachedLayer.vnode.componentInstance;
        } else {
            this.vnodeToCache = vnode;
        }

        vnode.data = vnode.data || {};
        vnode.data.keepAlive = true;

        return vnode;
    }
}
